import { render, staticRenderFns } from "./FireManage.vue?vue&type=template&id=15e485c8&scoped=true&"
import script from "./FireManage.vue?vue&type=script&lang=js&"
export * from "./FireManage.vue?vue&type=script&lang=js&"
import style0 from "./FireManage.vue?vue&type=style&index=0&id=15e485c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e485c8",
  null
  
)

export default component.exports